import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UpdatePrivacyPolicyComponent } from './update-privacy-policy.component';
import { IonicModule } from '@ionic/angular';
import { ReactiveFormsModule } from '@angular/forms';
import { ComponentsModule } from 'src/app/components/components.module';



@NgModule({
  declarations: [UpdatePrivacyPolicyComponent],
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    ComponentsModule
  ],
  exports:[
    UpdatePrivacyPolicyComponent
  ]
})
export class UpdatePrivacyPolicyModule { }
